import { Checkbox, Form } from 'antd';
import React from 'react';
import TranslationInput from 'components/TranslationInput';
import useUser from 'hooks/useUser';
import InputInfoCircle from 'components/InputInfoCircle';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const IntroStep = ({ name, survey, translations }) => {
  const { isSuperUser } = useUser();

  return survey ? (
    <>
      <h2>
        Survey intro
        <InputInfoCircle title={<FormattedMessage {...messages.introHelpText} />} iconStyle={{ marginLeft: 8, width: 16 }} />
      </h2>
      <TranslationInput primary={survey} translations={translations} name={[name, 'welcomePageContent']} />
      <Form.Item name={[name, 'showWelcomePage']} valuePropName="checked">
        <Checkbox>Show text on a separate welcome page and explicitly ask for participation</Checkbox>
      </Form.Item>
      {isSuperUser && (
        <Form.Item name={[name, 'hideIntroDisclaimer']} valuePropName="checked">
          <Checkbox>Hide disclaimer in intro (it will still be shown in the footer)</Checkbox>
        </Form.Item>
      )}
    </>
  ) : null;
};

export default IntroStep;
